import SelfStorageHero from 'assets/images/psp/hero/self-hero.webp';
import Moving from 'assets/images/psp/amenities/moving.svg';
import Renovating from 'assets/images/icons/psp/renovating.svg';
import Seasonal from 'assets/images/psp/six.svg';
import Downsizing from 'assets/images/icons/self-storage/downsize.svg';
import College from 'assets/images/icons/self-storage/collegesummer.svg';
import Emergencies from 'assets/images/psp/amenities/9.svg';
import { getUnitImageUrl } from '../../../utils/units';
import Self1 from 'assets/images/psp/FeaturedImages/self1.webp';
import Self2 from 'assets/images/psp/FeaturedImages/self2.webp';
import Self3 from 'assets/images/psp/FeaturedImages/self3.webp';
import Self4 from 'assets/images/psp/FeaturedImages/self4.webp';

const reviews = [
	{
		reviewTitle: 'Really easy to coordinate',
		reviewRating: 5,
		reviewText:
			'Really easy to coordinate online and to get to the unit during off hours!',
		reviewerInitials: 'MF',
		//
		reviewerName: 'Maegan F',
		reviewDate: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/68236238ca1d98d3f49209a7',
	},
	{
		reviewTitle: 'Saved me so much time by looking…',
		reviewRating: 5,
		reviewText:
			'This was a fast and easy search to find a storage unit near me with climate control. Very easy to reserve the unit for use as well.',
		reviewerInitials: 'JT',

		reviewerName: 'Judith Talarico',
		reviewDate: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/656df9349864d68ff85a9996',
	},
	{
		reviewTitle: 'Customer service',
		reviewRating: 5,
		reviewText:
			'The SpareFoot customer service representative listened to my needs and found me the absolute perfect place within 5 minutes!',
		reviewerInitials: 'L',

		reviewerName: 'Lee',
		reviewDate: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/681ccbe02c79ce86945f187e',
	},
	{
		reviewTitle: 'Very, very simple to book online',
		reviewRating: 5,
		reviewText:
			'Very, very simple to book online. I called the company right after, and they had my reservation. Will definitely use them again.',
		reviewerInitials: 'DM',

		reviewerName: 'Dara Matthews',
		reviewDate: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/68111eca0f2e258317455576',
	},
];
const faqs = [
	{
		question: 'What is self-storage?',
		answer:
			"[Self-storage](https://www.sparefoot.com/blog/what-is-self-storage-2) is a convenient service that provides secure, rentable storage space for personal belongings and business inventory. When you need extra room for items that don't fit in your home, garage, or office, self-storage facilities offer the perfect solution.\n\n" +
			'Self-storage provides flexibility, security, and convenience without the expense of moving to a larger home or office. With competitive monthly rates and various unit sizes, you only pay for the space you need. Most facilities offer online account management, automatic payments, and insurance options to protect your stored belongings.',
	},
	{
		question:
			'What are the main factors that affect the cost of a storage unit?',
		answer:
			'The cost of a storage unit depends on four factors:\n\n' +
			'- **Storage Unit Size**: Smaller storage units cost less, while larger units or those with extra features (such as [climate control](https://sparefoot.com/blog/do-you-need-climate-control-in-your-storage-unit)) come at a premium.\n\n' +
			'- **Storage Unit Location**: Interior units, units on the ground floor, and units near the elevator will typically cost more due to added convenience.\n\n' +
			'- **Storage Facility Location**: Prices are generally higher in urban areas and near city centers, and less in rural areas.\n\n' +
			'- **Storage Demand**: High demand in your area can drive the price up, while low occupancy often means better deals. \n\n',
	},
	{
		question: 'How much does a storage unit cost?',
		answer:
			'As we mentioned, the [cost of a storage unit](https://sparefoot.com/blog/how-much-does-a-storage-unit-cost) can vary based on factors such as location, unit size, and amenities. According to data in 2025, the average monthly prices for popular storage unit sizes is as follows:\n\n' +
			'- [5x5](https://sparefoot.com/blog/5x5-storage-unit-size-guide): $35.27\n\n' +
			'- [5x10](https://sparefoot.com/blog/5x10-storage-unit-size-guide): $51.47\n\n' +
			'- [10x10](https://sparefoot.com/blog/10x10-storage-unit-size-guide): $82.81\n\n' +
			'- [10x15](https://sparefoot.com/blog/what-can-you-fit-inside-of-a-10x15-storage-unit): $109.48\n\n' +
			'- [10x20](https://sparefoot.com/blog/10x20-storage-unit-size-guide): $132.43\n\n' +
			'- [10x30](https://sparefoot.com/blog/10x30-storage-unit-size-guide): $165.85\n\n',
	},
	{
		question: 'How can I guarantee I find the lowest price on storage?',
		answer:
			'Finding the lowest storage prices requires strategic comparison shopping, and storage marketplace platforms like SpareFoot make this process effortless by aggregating deals from hundreds of facilities in one place. Marketplace tools instantly compare storage unit prices across multiple facilities in your area, displaying real-time rates, availability, and special promotions.\n\n' +
			'Instead of calling dozens of storage facilities individually, you can view competitive pricing side-by-side and identify the best deals within minutes. Check out our exclusive [SpareFoot deals](https://www.sparefoot.com/storage-deals.html) to see if you can find the right unit at the right price today.',
	},
	{
		question: 'Do I Need a Climate-Controlled Unit?',
		answer:
			'You can determine whether you will need climate-controlled storage based on your items, your location, and the intended storage duration. If you are storing any climate-sensitive items such as electronics, wooden furniture, or photographs, a climate-controlled unit is recommended to prevent damage and preserve their condition.\n\n' +
			'A comprehensive list of items can be found on our [climate-controlled storage information page](https://www.sparefoot.com/climate-controlled-storage.html).',
	},
	{
		question: 'What type of lock do I need for my storage unit?',
		answer:
			'Use a high-quality, robust lock that is difficult to pick or cut. The most widely recommended types are disc locks, cylinder locks and closed-shackle padlocks.\n\n' +
			'Check out our [comprehensive guide on storage locks](https://www.sparefoot.com/blog/all-about-self-storage-locks) to know what to look for.',
	},
	{
		question: 'Do storage facilities offer insurance?',
		answer: 'Yes, [many storage facilities offer insurance](https://sparefoot.com/blog/does-homeowners-insurance-cover-storage-units), but you’re not required to get it from them. If you don’t already have coverage, you can choose their plan or compare it with other options to find a better deal.',
	},
	{
		question: 'Can the storage facility raise my rent?',
		answer:
			"Yes, rent increases are common in the storage industry and depend on market prices in your area. If you're concerned about a rent increase during your tenancy, review the lease carefully with your storage facility.\n\n" +
			"Make sure you're clear on notification procedures, should a rent increase occur.",
	},
	{
		question: 'What type of contract will I be required to sign?',
		answer: "[Self-storage contracts](https://sparefoot.com/blog/what-everyone-needs-to-know-about-self-storage-contracts) will include details about what you can keep in your unit, how you can access your unit, and most importantly, what happens when you're late on a payment or miss one altogether. Every self-storage rental agreement is different as terms may vary depending on the laws of the state where the facility is located.",
	},
];

export const SelfStorageContent = {
	type: 'Self',
	sections: [
		{
			title: 'Self-Storage',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'self-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Everything You Need to Know about Self-Storage',
							description:
								'Whether you’re moving, renovating, or just making room, self-storage is a simple and flexible solution to give you some extra space. With SpareFoot, it’s easy to find the right self-storage unit to fit your needs, short-term or long-term. Not sure where to start? We’re here to guide you through everything you need to know to make the right choice.',
							image: SelfStorageHero,
							CTAText: 'Find Self-storage',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			background: 'gray',
			noPaddingBottom: true,
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Self Storage Facilities Near',
					},
				},
			],
		},
		{
			title: 'Self Storage Size Comparison',
			noPaddingBottom: true,
			modules: [
				{
					title: 'Self Storage Content',
					type: 'content',
					props: {
						title: 'Why You Should Rent a Self-Storage Unit',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Storage units are for more than storing stuff you’re tired of tripping over. Here are some of the most popular reasons storage users choose storage to benefit their lifestyle. ',
						],
					},
				},
				{
					title: 'Self Storage moving reasons',
					type: 'unitList',
					id: 'self storage reasons cards',
					props: {
						slug: 'self-storage-reasons-cards',
						scrollFactor: 3,
						unitsData: [
							{
								image: Moving,
								content:
									'### Moving \n\n' +
									'Moving can get chaotic quickly. With self-storage’s flexible leasing plans, you can declutter, stage your home, or store items temporarily to make the process more managable.',
							},
							{
								image: Renovating,
								content:
									'### Renovating or Remodeling \n\n' +
									'Store your furniture and other items in a self-storage unit to protect them from construction dust and keep your space clear so that you can focus on your project.',
							},
							{
								image: Seasonal,
								content:
									'### Seasonal Storage \n\n' +
									'Snowmobile in the summer? Patio furniture in the winter? If you have nowhere to put them, consider a self-storage unit to keep them in tip-top shape while freeing up space at home.',
							},
							{
								image: Downsizing,
								content:
									'### Downsizing \n\n' +
									'If you’re moving into a smaller space but not ready to part with your things, self-storage units will give you room to keep what matters.',
							},
							{
								image: College,
								content:
									'### College Summers \n\n' +
									'Instead of hauling all your belongings back and forth when you’re heading home, keep them in a self-storage unit to save room in your car and make traveling stress-free.',
							},
							{
								image: Emergencies,
								content:
									'### Emergencies \n\n' +
									'When disaster strikes, whether it’s a flood, fire, or unexpected damage at home, self-storage units are a quick and reliable solution to protect your items, allowing you to focus on your recovery.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Storage Unit Size Guide',
			background: 'gray',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Self-Storage Unit Size Guide',
						contentType: 'row-type',
						ShowBackgroundImage: true,
						content: [
							'Our [Storage Unit Size Calculator](https://www.sparefoot.com/storage-unit-size-guide.html) can help you find the right self-storage unit size you need.',
						],
					},
				},
			],
		},
		{
			title: 'Self Storage Size Comparison',
			noPaddingBottom: true,
			modules: [
				{
					title: 'Self Storage Content',
					type: 'content',
					props: {
						title: 'Comparing Storage Unit Sizes',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Interested in learning more about the storage unit sizes available to you? We’ve broken it down with common unit dimensions and what will fit inside. ',
						],
					},
				},
				{
					title: 'Self Storage sizes',
					type: 'unitList',
					id: 'self storage size cards',
					props: {
						slug: 'self-storage-size-cards',
						scrollFactor: 3,
						unitsData: [
							{
								image: getUnitImageUrl(5, 5),
								content:
									'### [5x5](https://sparefoot.com/blog/5x5-storage-unit-size-guide) \n\n' +
									'**Average price:** $35.37 \n\n' +
									"**What will fit:** Small furniture and appliances, seasonal decorations, personal items, gardening equipment, camping gear, children's toys, off-season clothing.",
							},
							{
								image: getUnitImageUrl(5, 10),
								content:
									'### [5x10](https://sparefoot.com/blog/5x10-storage-unit-size-guide) \n\n' +
									'**Average price:** $51.47 \n\n' +
									'**What will fit:**  Furniture from a one-bedroom apartment or dorm room including a queen-sized mattress set, love seat, dresser, TV, bike and several storage boxes.',
							},
							{
								image: getUnitImageUrl(10, 10),
								content:
									'### [10x10](https://sparefoot.com/blog/10x10-storage-unit-size-guide) \n\n' +
									'**Average price:** $82.81 \n\n' +
									'**What will fit:** Items from two bedrooms (mattresses sets, dressers, nightstands) and an entire family room (sofa, chairs, coffee table, book shelves).',
							},
							{
								image: getUnitImageUrl(10, 15),
								content:
									'### [10x15](https://sparefoot.com/blog/what-can-you-fit-inside-of-a-10x15-storage-unit) \n\n' +
									'**Average price:** $109.48 \n\n' +
									'**What will fit:** Items from three bedrooms and other large items like big-screen TVs, couches, pianos, tables or appliances.',
							},
							{
								image: getUnitImageUrl(10, 20),
								content:
									'### [10x20](https://sparefoot.com/blog/10x20-storage-unit-size-guide) \n\n' +
									'**Average price:** $132.43 \n\n' +
									'**What will fit:** Items from a three- or four-bedroom house or apartment, including couches, mattress sets, a dining room set, workout equipment, a refrigerator, washer, and dryer.',
							},
							{
								image: getUnitImageUrl(10, 30),
								content:
									'### [10x30](https://sparefoot.com/blog/10x30-storage-unit-size-guide) \n\n' +
									'**Average price:** $165.85 \n\n' +
									'**What will fit:** Items from a fully furnished five-bedroom house including mattress sets, dressers, couches, major appliances, seasonal items, outdoor equipment, and bikes.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Self Storage items Table',
			background: 'gray',
			modules: [
				{
					type: 'sizeChart',
					props: {
						title: 'What can you store in a Self-Storage unit?',
						headers: [
							{
								label: 'Items you can store',
								key: 'Items you can store',
							},
							{
								label: 'Items you cannot store',
								key: 'Items you cannot store',
							},
						],
						rows: [
							{
								'Items you can store': 'Furniture',
								'Items you cannot store': 'Money',
							},
							{
								'Items you can store':
									'Household goods (artwork, books, home decor, etc.)',
								'Items you cannot store':
									'Live animals or plants',
							},
							{
								'Items you can store': 'Sports equipment',
								'Items you cannot store': 'Stolen property',
							},
							{
								'Items you can store': 'Commercial goods',

								'Items you cannot store': 'Hazardous materials',
							},
							{
								'Items you can store': 'Electronics',
								'Items you cannot store': 'Noxious materials',
							},
							{
								'Items you can store': 'Appliances',
								'Items you cannot store': 'Flammable materials',
							},
							{
								'Items you can store':
									'Cars, boats, motorcycles, and RVs',
								'Items you cannot store':
									'Perishable items, like food',
							},
							{
								'Items you can store': 'Alcohol',
								'Items you cannot store': 'Illegal drugs',
							},
							{
								'Items you can store': '',
								'Items you cannot store': 'Explosives',
							},
							{
								'Items you can store': '',
								'Items you cannot store':
									'Firearms, ammunition or weapons caches',
							},
							{
								'Items you can store': '',
								'Items you cannot store':
									'Unregistered or uninsured vehicles',
							},
							{
								'Items you can store': '',
								'Items you cannot store': 'Tires',
							},
							{
								'Items you can store': '',
								'Items you cannot store': 'Furs',
							},
							{
								'Items you can store': '',
								'Items you cannot store': 'Wet items',
							},
						],
					},
				},
			],
		},
		{
			title: 'New Video Section',
			background: 'white',
			modules: [
				{
					type: 'videoSection',
					props: {
						slug: 'How to Pick the Right Storage Unit Size Video',
						src: 'https://www.youtube.com/embed/pNjSkBAJzGI',
						theme: 'light',
						content: {
							title: 'Choose between different self storage amenities',
							description:
								'Not all storage units are made the same. Whether you need [climate control](https://www.sparefoot.com/climate-controlled-storage.html) to protect your belongings, 24-hour self-storage for accessibility, or [drive-up access](https://sparefoot.com/blog/drive-up-storage-units) for bulky items, there’s a setup that fits your needs. Watch our video to see what amenities make the most sense for you.',
						},
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: 'What SpareFoot’s Self Storage Customers Are Saying',
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Self Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			noPaddingTop: true,
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'rv-featured-content',
						contentCards: [
							{
								title: 'Self Storage',
								date: 'October 22, 2025',
								image: Self1,
								link: 'https://sparefoot.com/blog/what-is-self-storage-2',
								content: 'What Is Self-Storage?',
							},
							{
								title: 'General Storage Advice',
								date: 'August 07, 2025',
								image: Self2,
								link: 'https://sparefoot.com/blog/how-to-pick-the-right-size-storage-unit',
								content:
									'How to Pick the Right Size Self-Storage Unit',
							},
							{
								title: 'General Storage Advice',
								date: 'August 04, 2025',
								image: Self3,
								link: 'https://sparefoot.com/blog/tips-for-choosing-a-self-storage-facility',
								content:
									'Tips for Choosing a Self-Storage Facility',
							},
							{
								title: 'General Storage Advice',
								date: 'October 22, 2025',
								image: Self4,
								link: 'https://sparefoot.com/blog/saving-money-on-self-storage',
								content:
									'9 Ways to Save Money on a Storage Unit',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'Car',
							'RV',
							'Boat',
							'ClimateControl',
							'College',
							'Portable',
							'Business',
							'Vehicle',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
